import {
  SUCCESS_AXIOS_CALL,
  FAILED_AXIOS_CALL,
  RESET_AXIOS_CALL,
} from './types';

export const axiosSuccessStatus = () => ({
  type: SUCCESS_AXIOS_CALL,
});

export const axiosFailedStatus = () => ({
  type: FAILED_AXIOS_CALL,
})

export const axiosResetStatus = () => ({
  type: RESET_AXIOS_CALL,
})
